import React from "react";
import "./about.css";
import leftAbout from "../../images/aboutUs/aboutLeft.png";
import rightAbout from "../../images/aboutUs/aboutRight.png";
import aboutUsRiffle from "../../images/aboutUs/aboutUsRiffle.png";
import localCrew from "../../images/aboutUs/localCrew.png";
import gtweb from "../../images/aboutUs/gt_web.png";

const Aboutus = () => {
  return (
    <>
      <div className="relative w-full min-h-screen ">
        {/* Background Image - Full Width */}
        <div className="absolute inset-0 w-full h-full  bg-cover bg-center bgAboutBanner z-0"></div>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

        {/* Content Wrapper */}
        <div className="relative z-10 flex flex-col items-center justify-center h-screen text-center text-white px-4">
          <div className="flex flex-col gap-4 ">
            <div className="flex gap-3 justify-center">
              <div className="text-base poppins-medium">HOME</div>
              <div className="text-base poppins-medium">/</div>
              <div className="text-base poppins-medium"> ABOUT US</div>
            </div>
            <h2 className="text-3xl md:text-6xl font-normal ">
              ABOUT <span className="text-[#D1A752] underline"> US</span>
            </h2>
          </div>
        </div>
      </div>
      <div
        className="flex md:gap-16  gap-4 justify-center relative z-20"
        style={{ marginTop: "-100px" }}
      >
        <div>
          <img
            src={leftAbout}
            alt="leftAbout"
            className="relative z-30 max-md:w-[180px]"
          />
        </div>
        <div>
          <img
            src={rightAbout}
            alt="rightAbout"
            className="relative z-30 max-md:w-[180px]"
          />
        </div>
      </div>

      {/* elegent Component */}
      <div className="mt-16 ml-8 max-md:px-4">
        <div
          className="md:flex gap-4 items-center"
          style={{ maxWidth: "1440px", margin: "auto" }}
        >
          <div className="md:w-[50%] flex flex-col gap-4">
            <div className="text-xl text-[#585858] poppins-medium">
              THE SYNERGY OF SUSTAINABILITY & NATURAL BEAUTY
            </div>
            <div className="text-[42px] text-[#672220] font-bold">
              Gir Glades: Where Conservation Meets Luxury
            </div>
            <div className="text-xl text-[#5A5A5A]  max-[742px] poppins-medium">
              Gir Glades is the perfect forest retreat for travelers seeking a
              blend of adventure and relaxation on their holidays.
            </div>

            <div className="text-xl text-[#5A5A5A]  mt-2 max-[742px] poppins-medium">
              The owner is a renowned shooter whose thought behind our hanging villa was firm and uncomplicated — creating an eco-friendly, wildlife-centred luxury retreat. Gir Glades brings nature right into your backyard and creates a safe haven for animals that can move freely on the property.
            </div>
            <div className="md:text-xl text-lg text-[#5A5A5A] poppins-medium mt-4">
              At Gir Glades, you don't just stay you find a home in the heart of
              the forest.
            </div>
          </div>
          <div className="md:w-[50%] flex justify-center">
            <div className="image-container">
              <img src={aboutUsRiffle} alt="Gir Glades Owner" className="styled-image"/>
            </div>
          </div>
        </div>
      </div>

      {/* Local Crew Architecture Section */}
      <div className="mt-16 ml-8 max-md:px-4">
        <div
          className="flex flex-col md:flex-row gap-4 items-center"
          style={{ maxWidth: "1440px", margin: "auto" }}
        >
          <div className="md:w-[50%] flex justify-center order-2 md:order-1">
            <div className="image-container">
              <img src={localCrew} alt="Local Crew Architects" className="styled-image"/>
            </div>
          </div>
          <div className="md:w-[50%] flex flex-col gap-4 order-1 md:order-2">
            <div className="text-xl text-[#585858] poppins-medium">
              THE ARCHITECTS BEHIND THE VISION
            </div>
            <div className="text-[44px] text-[#672220] font-bold">
              Crafted by The Local Crew
            </div>
            <div className="text-xl text-[#5A5A5A] poppins-medium">
              The Gir Glades villa is the brain-child of The Local Crew — a multi-disciplinary studio that creates awe-inspiring spaces by combining architecture, interior design, and landscape design.
            </div>
            <div className="text-xl text-[#5A5A5A] mt-2 poppins-medium">
              Elevated on eight columns to preserve the terrain and mango orchards, this architectural retreat rests over a natural lion trail with cantilevered bedrooms opening to sweeping forest views.
            </div>
          </div>
        </div>
      </div>
      
      {/* Gujarat Tourism Component */}
      <div className="pt-8 max-md:px-4">
        <div className="md:flex gap-4 items-center" style={{ maxWidth: "1440px", margin: "auto" }}>
          <div className="md:w-[50%] flex flex-col gap-4 justify-center gujarat-tourism-text">
            <div className="text-[42px] text-[#672220] font-bold">
            Platinum Homestay Recognition
            </div>
            <div className="text-xl text-[#5A5A5A]  max-[742px] poppins-medium">
            Gir Glades is more than a destination — it’s a proud emblem of heritage, nature, and trust. Officially recognized by Gujarat Tourism, 
            a division of the Government of Gujarat, our property meets the highest standards of hospitality, safety, and sustainability expected from the state’s most treasured getaways.
            </div>

            <div className="text-xl text-[#5A5A5A]  mt-2 max-[742px] poppins-medium">
            <span className="font-bold">As a designated Platinum‑category property under Gujarat Tourism’s homestay classification</span>, Gir Glades offers superior quality, premium amenities, and an exceptional guest experience. Nestled in the world-renowned Gir Forest, Gir Glades offers guests the unique opportunity to experience the last natural habitat of the Asiatic lion. This rare and protected species has roamed these forests for centuries, making Gir a symbol of India’s commitment to wildlife conservation.
            </div>
          </div>
          <div className="md:w-[50%] flex justify-center">
            <div className="image-container gujarat-tourism-container">
              <img src={gtweb} alt="Gujarat Tourism Recognition" className="styled-image"/>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default Aboutus;
